import "backbone-associations";
import "underscore";
import { AppSettings } from "../../app-settings";
import { prop } from "../../decorators/property";
import { autoinject } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import {ReportStatusCollection} from "../collections/report-status";
import {FileStatusCollection} from "../collections/file-status";
import {ReportStatusModel} from "../models/report-status";
import {FileStatusModel} from "../models/file-status";

@autoinject
@backboneModelProperties({
    defaults: {
        ReportStatuses: [],
        FileStatuses: [],
    },
    relations: [
        {
            key: "ReportStatuses",
            relatedModel: ReportStatusModel,
            type: Backbone.Many,
        },
        {
            key: "FileStatuses",
            relatedModel: FileStatusModel,
            type: Backbone.Many,
        }
    ],
    urlRoot: AppSettings.ProcessingApiUrlPrefix + "importstatus"
})
export class ImportModel extends Backbone.AssociatedModel {

    @prop() public ReportStatuses: ReportStatusCollection;
    @prop() public FileStatuses: FileStatusCollection;

    constructor(options?) {
        super(options);
    }

    public load(dataSource = "") {
        let queryString = "";
        if (dataSource) {
            queryString = `/?dataSource=${dataSource}`;
        }
        return Promise.resolve(this.fetch({
            url: this.urlRoot + queryString,
            success: () => {
                Promise.resolve();
            },
            error: () => {
                Promise.reject("Server Error");
            }

        }));
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/models/Import.ts